export const formatRole = (role: string) => {
  if (!role) return "";
  return role
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
